import { call, put, takeEvery, takeLatest, takeLeading } from "redux-saga/effects";
import { types } from "../action-types";
import { updateBidApi, fetchDeclinedReasonsBidsAPI } from "../../API/API";
import { fetchDeclinedReasonsBidsSuccess, fetchDeclinedReasonsBidsFailure } from "../actions";

function* updateBidSaga(params) {
  try {
    const response = yield call(updateBidApi, params);
    yield put({ type: types.UPDATE_BID_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.UPDATE_BID_FAILURE, error });
  }
}

function* fetchDeclinedReasonsBidsSaga(params) {

  try {
    const response = yield call(() =>
      fetchDeclinedReasonsBidsAPI(params.payload)
    ); // API Backend
    // console.log("declinedReasonsDataSaga:", response.data.data);
    if (response.status == 200) {
      yield put(fetchDeclinedReasonsBidsSuccess(response.data.data));
    } else {
      yield put(fetchDeclinedReasonsBidsFailure(response));
    }
  } catch (error) {
    yield put(fetchDeclinedReasonsBidsFailure(error));
  }
}

export function* watchFetchDeclinedReasonsBids() {
  yield takeLeading(
    types.FETCH_DECLINED_REASONS_BIDS_INIT,
    fetchDeclinedReasonsBidsSaga
  );
}
export function* watchUpdateBidSaga() {
  yield takeLeading(types.UPDATE_BID_REQUESTED, updateBidSaga);
}
